import axios from './../axios'

export default async function (action, args, displayId, payload) {
    console.log('cart-rule-action:add_product', { action, args })

    const products = Object.values(window.addiesaas.products.types)
        .flat(1)

    const product = products.find(p => p.id == action.options.product_id)

    if (product.is_customer_input_required) {
        payload.redirect = product.product_form_url
        return
    }

    let options = action.options.options || null
    if (options) {
        options = window.addiesaas.$fn.formatters.templify(JSON.parse(options), args)
    }

    const config = window.addiesaas.config

    const { data: extendedOptions } = await axios.post(`${config.apiUri}/customer/product/${product.id}/extend-options`, {
        user_id: options ? options.user_id || null : null,
        options,
    })
    options = extendedOptions

    let count = action.options.count_option || action.options.count || 1
    count = window.addiesaas.$fn.formatters.templify(count, args)

    const store = window.addiesaas.store

    const cartLocationId = store.getters['REUtils/Cart/cartLocationId']

    const itemId = (new Date).getTime()

    const item = {
        id: itemId,
        type: product.type,
        name: product.name,
        title: product.title,
        total: product.price * count,
        count,
        payload: {
            product_id: action.options.product_id,
            count,
            options: Object.assign(options || {}, {
                cart_rule_display_id: displayId,
                cart_location_id: cartLocationId,
            })
        },
        attributes: {
            product,
        },
        editable: false,
        removable: false,
    }

    await store.dispatch('Shop/Orders/Cart/addCartItem', item)

    window.addiesaas.$core.EventBus.$emit('cart.validate')

    payload.upsell_value = product.price * count

    payload.revertCallback = () => {
        store.dispatch('Shop/Orders/Cart/removeCartItem', { id: itemId })
    }

    if (typeof args.item !== 'undefined') {
        const parentItem = _.cloneDeep(store.getters['Shop/Orders/Cart/cartItems'][args.item.id])

        parentItem.cartRuleAddedCartItemIds = parentItem.cartRuleAddedCartItemIds || []
        parentItem.cartRuleAddedCartItemIds.push(itemId)

        await store.dispatch('Shop/Orders/Cart/updateCartItemSilent', parentItem)
    }
}
